import React from 'react';
import { useTranslation } from 'react-i18next';
import { PACKAGE_CHANGE_TYPES } from '@src/constants/package';
import {
  checkCustomPackage,
  getPackageChangeType,
  getPackageNameV3,
} from '@src/services/package';
import { useSelector } from 'react-redux';
import { StyledDialogUpDownGradeV3 } from '../../index.style';
import Content from './Content';

const PopupNoticeRolloverOrder = ({ creditsOrderData }) => {
  const { usingPackage } = useSelector((state) => state.user);
  const { user } = useSelector((state) => state.auth);
  const { package: packageState } = useSelector((state) => state.order);
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const packageName = (pack) =>
    getPackageNameV3(pack?.name, pack?.code, language, t);

  const packageChangeType = getPackageChangeType({
    currPackage: packageState,
    prevPackage: usingPackage,
    prevPackageExpiredDate: user?.packageExpiryDate,
  });
  const isDowngrade = packageChangeType === PACKAGE_CHANGE_TYPES.DOWNGRADE;
  const isCustomPackage = checkCustomPackage({
    level: usingPackage.level,
    type: usingPackage.type,
  });

  const levelText = () => {
    if (isDowngrade || isCustomPackage) return t('downV2');

    return t('changeV2');
  };

  return (
    <StyledDialogUpDownGradeV3>
      <div className="content-wrapper">
        <div className="content">
          {((packageChangeType && packageState?.cycle) ||
            (isCustomPackage && packageState?.cycle) ||
            (usingPackage?.cycle && !packageState?.cycle)) && (
            <div
              className="sub-title-v3"
              component="span"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: t('changeFromPackageTitleV3', {
                  prefix: levelText(),
                  fromPackage: packageName(usingPackage),
                  toPackage: packageName(packageState),
                }),
              }}
            />
          )}
          <Content
            usingPackage={usingPackage}
            packageState={packageState}
            creditsOrderData={creditsOrderData}
          />
        </div>
      </div>
    </StyledDialogUpDownGradeV3>
  );
};

export default PopupNoticeRolloverOrder;
